(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gant-club-newsletter"] && !Shopify.designMode) return;
  try {
    
  // Unified Drawer System
  class DrawerManager {
    constructor() {
      this.init();
    }

    init() {
      // Add event listeners for drawer triggers
      document.querySelectorAll('.drawer-trigger').forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          const targetId = trigger.getAttribute('data-drawer-target');
          const drawerType = trigger.getAttribute('data-drawer-type');
          this.openDrawer(targetId, drawerType);
        });
      });

      // Add event listeners for drawer close buttons
      document.querySelectorAll('.drawer-close').forEach((closeBtn) => {
        closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeDrawer(closeBtn.closest('.drawer-panel'));
        });
      });

      // Add event listeners for overlay clicks
      document.querySelectorAll('.drawer-overlay').forEach((overlay) => {
        overlay.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeDrawer(overlay.closest('.drawer-panel'));
        });
      });

      // Close drawer on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.closeAllDrawers();
        }
      });
    }

    openDrawer(targetId, drawerType) {
      const drawer = document.getElementById(targetId);
      if (!drawer) return;

      // Show drawer
      document.body.classList.add('overflow-hidden');
      drawer.classList.remove('hidden');

      // Focus management - focus on first input
      const firstInput = drawer.querySelector('input[type="email"]');
      if (firstInput) {
        setTimeout(() => firstInput.focus(), 100);
      }
    }

    closeDrawer(drawer) {
      if (!drawer) return;

      document.body.classList.remove('overflow-hidden');
      drawer.classList.add('hidden');
    }

    closeAllDrawers() {
      document.querySelectorAll('.drawer-panel').forEach((drawer) => {
        this.closeDrawer(drawer);
      });
    }
  }

  // Initialize drawer system when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    new DrawerManager();
  });

  // Make drawer manager globally available
  window.DrawerManager = DrawerManager;

  // Form submission handling
  const newsletterForm = document.getElementById('newsletterForm');
  const wishlistForm = document.getElementById('wishlistForm');

  if (newsletterForm) {
    newsletterForm.addEventListener('submit', handleFormSubmit);
  }

  if (wishlistForm) {
    wishlistForm.addEventListener('submit', handleFormSubmit);
  }

  function handleFormSubmit(e) {
    e.preventDefault();

    const form = e.target;
    const formId = form.id;
    const submitBtn = form.querySelector('button[type="submit"]');
    const errorDiv = form.querySelector('[id*="form-errors"]');
    const successDiv = form.querySelector('[id*="form-success"]');

    // Reset previous states
    errorDiv.classList.add('hidden');
    successDiv.classList.add('hidden');

    // Disable submit button
    submitBtn.disabled = true;
    submitBtn.textContent = 'Creating Account...';

    // Collect form data
    const formData = new FormData(form);

    // Submit to Shopify
    fetch(form.action, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: new URLSearchParams(formData),
    })
      .then((response) => {
        if (response.ok) {
          // Success - account created
          successDiv.classList.remove('hidden');
          form.reset();

          // Close drawer after success
          setTimeout(() => {
            if (formId === 'newsletterForm') {
              document.getElementById('newsletterPanel').classList.add('hidden');
            } else if (formId === 'wishlistForm') {
              document.getElementById('wishlistPanel').classList.add('hidden');
            }
          }, 2000);
        } else {
          // Handle errors
          return response.text().then((text) => {
            throw new Error(text);
          });
        }
      })
      .catch((error) => {
        console.error('Form submission error:', error);

        // Display error message
        errorDiv.innerHTML = '<p>Sorry, there was an error creating your account. Please try again.</p>';
        errorDiv.classList.remove('hidden');

        // Try to parse specific Shopify errors
        if (error.message.includes('already exists')) {
          errorDiv.innerHTML =
            '<p>An account with this email already exists. Please <a href="/account/login" class="underline">log in</a> or use a different email.</p>';
        } else if (error.message.includes('invalid')) {
          errorDiv.innerHTML = '<p>Please check your information and try again.</p>';
        }
      })
      .finally(() => {
        // Re-enable submit button
        submitBtn.disabled = false;
        submitBtn.textContent = formId === 'newsletterForm' ? 'Join Now' : 'Join & Create Wishlist';
      });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        const announcementBar = document.querySelector('.utility-bar');
        if (announcementBar) {
          announcementBar.classList.add('shopify-section-header-sticky');
        }
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      const announcementBar = document.querySelector('.utility-bar');
      const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
      const totalHeaderHeight = this.header.offsetHeight + announcementBarHeight;
      document.documentElement.style.setProperty('--header-height', `${totalHeaderHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Debounce scroll events to prevent jittering
      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
      }

      this.scrollTimeout = setTimeout(() => {
        // Only trigger state changes if scroll direction has meaningfully changed
        const scrollDelta = Math.abs(scrollTop - this.currentScrollTop);
        if (scrollDelta < 5) return; // Ignore small scroll movements

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          if (!this.header.classList.contains('shopify-section-header-hidden')) {
            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            if (this.header.classList.contains('shopify-section-header-hidden')) {
              requestAnimationFrame(this.reveal.bind(this));
            }
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            if (!this.header.classList.contains('shopify-section-header-hidden')) {
              requestAnimationFrame(this.hide.bind(this));
            }
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          if (
            this.header.classList.contains('shopify-section-header-hidden') ||
            this.header.classList.contains('shopify-section-header-sticky')
          ) {
            requestAnimationFrame(this.reset.bind(this));
          }
        }

        this.currentScrollTop = scrollTop;
      }, 10); // Small delay to debounce scroll events
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      const announcementBar = document.querySelector('.utility-bar');
      if (announcementBar) {
        announcementBar.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      }
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
      this.header.classList.remove('shopify-section-header-hidden');
      const announcementBar = document.querySelector('.utility-bar');
      if (announcementBar) {
        announcementBar.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        announcementBar.classList.remove('shopify-section-header-hidden');
      }

      // Remove slide-down class after animation completes
      setTimeout(() => {
        this.header.classList.remove('slide-down');
        if (announcementBar) {
          announcementBar.classList.remove('slide-down');
        }
      }, 300);
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate',
        'slide-down'
      );
      const announcementBar = document.querySelector('.utility-bar');
      if (announcementBar) {
        announcementBar.classList.remove(
          'shopify-section-header-hidden',
          'shopify-section-header-sticky',
          'animate',
          'slide-down'
        );
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal !== null) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
